import React, {useContext, useEffect, useState} from "react";
import {Col, Container, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {
    dateToString,
    getCurBusDate, getMaxYear4DigitsFormat,
    getMinPermissibleBusDate,
    pickerDateFormatToDate,
    yearMonthDayToPickerDateFormat
} from "utils/FormatUtils";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {SWIFT_WIRES_PANEL_ACTIVITIES_PAGE} from "./context/SwiftWiresContext";
import {ToastContext} from "context/Toast";
import {EntityAccountsContext} from "components/entity-accounts/context";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {FilterContext} from "layouts/SidePanelLayout";
import {isValidDate, validateValueOnRegex} from "../../../utils/RegexUtils";
import {getAllErrorValuesAsString, updateSwiftWiresFormErrors} from "../../../utils/ErrorUtils";
import {SwiftWiresContext} from "./context";
import {normaliseFilterValueAllToEmptyString} from "../../../utils/StringUtils";
import {SWIFT_WIRES_URL_SEARCH} from "service/UrlConstant";
import {TRANS_ID_FIELD_MAX_LENGTH, REFERENCE_FIELD_MAX_LENGTH} from "../../../utils/Constants";
import {REFERENCE_FIELD_MAX_LENGTH_MSG, TRANS_ID_FIELD_MAX_LENGTH_MSG} from "../../../utils/ConstantsMsg";

export const swiftWiresRefTypesJSON = [
    { "id": "", "name": "Any" },
    { "id": "FED", "name": "Fed Ref" },
    { "id": "IVN", "name": "Ivan Ref" },
    { "id": "OTH", "name": "Other Ref" }
];

const swiftWiresStatusesJSON = [
    { "id": "", "name": "Any" },
    { "id": "ERROR", "name": "ERROR" },
    { "id": "ACK", "name": "ACK" },
    { "id": "CMPLT", "name": "COMPLETED" },
];
const swiftWiresDirectionsJSON = [
    { "id": "", "name": "Any" },
    { "id": "OUT", "name": "OUT" },
    { "id": "IN", "name": "IN" }
];


export default function SwiftWiresFilter() {

    const FIELD_MAX_LENGTH = 16;
    const FIELD_MAX_LENGTH_MSG = `Maximum ${FIELD_MAX_LENGTH} characters allowed.`;

    const {
        swiftWiresDisplayState,
        setSwiftWiresDisplayState,
        clearSwiftWiresSearchAndLoadTradingHome,
        setShowGridToolbar,
        setHeaderCheckedboxChecked,
        setSelectedRows,
        setSelectedAnyCheckbox,
        setColumnState,
        handlePageRequest
    } = useContext(SwiftWiresContext);
    const {entityAccountsNoSwap, clearEntityAccounts, setManagerAndAccountDetails, validateEntityAccountSearch, paramBadgeInfo, populateDefaultEntity, entityAccountsOptionsNoSwap} = useContext(EntityAccountsContext);

    const {makePostRequest} = useContext(SecurityContext);
    const {alert, error} = useContext(ToastContext);
    const [formErrors, setFormErrors] = useState({});
    const [accountOptional, setAccountOptional] = useState(true);
    const {showFilter, setShowFilter} = useContext(FilterContext);
    const [actualTransfers, setActualTransfers] = useState(false);


    const handleSearchOnChange = (e) => {
        let swiftWiresDisplayStateUpdated = JSON.parse(JSON.stringify(swiftWiresDisplayState));
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        swiftWiresDisplayStateUpdated.swiftWiresActivitiesSearch[targetName] = targetValue;
        setSwiftWiresDisplayState(swiftWiresDisplayStateUpdated);

        updateSwiftWiresFormErrors(targetName, targetValue,
            formErrors, setFormErrors);

        if (targetName === 'reference' || targetName === 'transId') {
            setFormErrors((prevFormErrorsState) => ({
                ...prevFormErrorsState,
                [targetName]: targetValue.length > FIELD_MAX_LENGTH ? FIELD_MAX_LENGTH_MSG : ''
            }));
        }
    }

    const handleSearchClear = (e) => {
        clearEntityAccounts(true, true, true);
        clearSwiftWiresSearchAndLoadTradingHome();
        setAccountOptional(true)
    }


    const validateSearch = ()=>{
        let errors = {};
        const {reference, transId} = swiftWiresDisplayState.swiftWiresActivitiesSearch;

        if ((reference || '').length > REFERENCE_FIELD_MAX_LENGTH) {
            errors.reference = REFERENCE_FIELD_MAX_LENGTH_MSG;
        }

        if ((transId || '').length > TRANS_ID_FIELD_MAX_LENGTH) {
            errors.transId = TRANS_ID_FIELD_MAX_LENGTH_MSG;
        }

        return errors
    }

    const swiftWiresHandleSearchClick = (e) => {
        e.preventDefault();

        const errors = validateSearch();
        if (Object.keys(errors).length > 0) {
            setFormErrors((prevFormErrorsState) => ({
                ...prevFormErrorsState,
                ...errors
            }));
            return;
        }

        const searchCriteria = {
            refType: swiftWiresDisplayState.swiftWiresActivitiesSearch.refType,
            indStatus: swiftWiresDisplayState.swiftWiresActivitiesSearch.status,
            transId: swiftWiresDisplayState.swiftWiresActivitiesSearch.transId,
            reference: swiftWiresDisplayState.swiftWiresActivitiesSearch.reference,
            mnyOut: swiftWiresDisplayState.swiftWiresActivitiesSearch.direction === 'IN' ? 0 : null,
            mnyIn: swiftWiresDisplayState.swiftWiresActivitiesSearch.direction === 'OUT' ? 0 : null,
            dtEffective: dateToString(swiftWiresDisplayState.swiftWiresActivitiesSearch.dtEffective)
        }

        setShowFilter(!showFilter)

        const onSuccessResponse = (response) => {

            let swiftWiresDisplayStateShowActivities = {...swiftWiresDisplayState};
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.managerId = searchCriteria.managerId;
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.subManagerId = searchCriteria.subManagerId;
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.accountId = searchCriteria.accountId;
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.managerName = entityAccountsNoSwap.managerName;
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.subManagerName = entityAccountsNoSwap.subManagerNameShort;
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.accountName = entityAccountsNoSwap.accountName;
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.accountCode = entityAccountsNoSwap.accountCode;
            swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.badgeInfo = paramBadgeInfo(true);

            if (!response.data || response.data.length === 0) {
                swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.resData = [];
                alert('No SwiftWires found matching your search');
            } else {
                swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.resData = response.data;
            }
            setShowGridToolbar(response.data && response.data.length > 0)
            swiftWiresDisplayStateShowActivities.currentPage = SWIFT_WIRES_PANEL_ACTIVITIES_PAGE;
            setSwiftWiresDisplayState(swiftWiresDisplayStateShowActivities);
            setColumnState(null);


        }

        const onErrorResponse = (err) => {
            let errorMsg = getAllErrorValuesAsString(err.response.data)
            console.error("Error occurred with searching SwiftWires",errorMsg);
            error("Error occurred with searching SwiftWires");
        }

        makePostRequest(searchCriteria,
            URL.SWIFT_WIRES_URL_SEARCH, onSuccessResponse, onErrorResponse);

        setHeaderCheckedboxChecked(false);
        setSelectedAnyCheckbox(false)
        setSelectedRows([]);

    }

    return (<>
        <Container fluid className="mt-md-3 mt-sm-0">
            <Form>
                <h2 className="d-none d-md-block">Search</h2>
                <Row>
                    <Col md={12}>
                        <Form.Group controlId="formGridRefType" className={'td-select'} >
                            <Form.Label className="filter-input-label">Ref Type:</Form.Label>
                            <Form.Control as="select" name="refType"
                                          value={swiftWiresDisplayState.swiftWiresActivitiesSearch.refType}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.refType}>
                                {
                                    swiftWiresRefTypesJSON.map(item =>
                                        <option key={item['id']} value={item['id']}>{item['name']}</option>
                                    )
                                }
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.refType}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridReference">
                            <label className='filter-input-label'>Reference:</label>

                                <FormControl
                                             placeholder="" name="reference"
                                             value={swiftWiresDisplayState.swiftWiresActivitiesSearch.reference}
                                             onChange={handleSearchOnChange}
                                             isInvalid={!!formErrors.reference}
                                />
                                <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.reference}</b></Form.Control.Feedback>

                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridTransId">
                            <label className='filter-input-label'>Trans ID:</label>
                                <FormControl
                                    placeholder="" name="transId"
                                    value={swiftWiresDisplayState.swiftWiresActivitiesSearch.transId}
                                    onChange={handleSearchOnChange}
                                    isInvalid={!!formErrors.transId}
                                />
                                <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.transId}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridStatus" className={'td-select'} >
                            <Form.Label className="filter-input-label">Status:</Form.Label>
                            <Form.Control as="select" name="status"
                                          value={swiftWiresDisplayState.swiftWiresActivitiesSearch.status}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.status}>
                                {
                                    swiftWiresStatusesJSON.map(item =>
                                        <option key={item['id']} value={item['id']}>{item['name']}</option>
                                    )
                                }
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.status}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridDirection" className={'td-select'} >
                            <Form.Label className="filter-input-label">Direction:</Form.Label>
                            <Form.Control as="select" name="direction"
                                          value={swiftWiresDisplayState.swiftWiresActivitiesSearch.direction}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.direction}>
                                {
                                    swiftWiresDirectionsJSON.map(item =>
                                        <option key={item['id']} value={item['id']}>{item['name']}</option>
                                    )
                                }
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.direction}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={12} className={'py-0'}>
                        <Form.Group controlId="formSwiftWireDate">
                            <Form.Label className="filter-input-label" > Effective Date </Form.Label>
                            <Form.Control type="date" name="dtEffective" value={swiftWiresDisplayState.swiftWiresActivitiesSearch.dtEffective} onChange={handleSearchOnChange} isInvalid={!!formErrors.dtEffective}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.dtEffective}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" href="#"
                                onClick={swiftWiresHandleSearchClick}>Search
                        </button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3"
                                href="#" onClick={handleSearchClear}>Clear
                        </button>
                    </Col>
                </Row>
            </Form>
        </Container>
    </>);

}
